const LOADING = '[LOADING]';

// export const DISABLE_LOADING = false;
// export const ENABLE_LOADING = true;

export const ENABLE_LOADING = `${LOADING} ENABLE`;
export const DISABLE_LOADING = `${LOADING} DISABLE`;

export const enableLoading = () => ({
    type: ENABLE_LOADING,
    payload: true
});

export const disableLoading = () => ({
    type: DISABLE_LOADING,
    payload: false
});
